const BASE_URL: string = process.env.REACT_APP_API_KEY || '';
// const BASE_URL:string='http://localhost:8084';

// Master Main Group
export const MASTER_MAIN_GROUP_FIND_MANY: string =
  BASE_URL + '/categories/master-main-group/find-many';
export const MASTER_MAIN_GROUP_CREATE: string = BASE_URL + '/categories/master-main-group/create';
export const MASTER_MAIN_GROUP_UPDATE: string =
  BASE_URL + '/categories/master-main-group/update?id=';
export const MASTER_MAIN_GROUP_DELETE: string =
  BASE_URL + '/categories/master-main-group/delete?id=';

// Master Division
export const MASTER_DIVISION_FIND_MANY: string = BASE_URL + '/categories/master-division/find-many';
export const MASTER_DIVISION_CREATE: string = BASE_URL + '/categories/master-division/create';
export const MASTER_DIVISION_UPDATE: string = BASE_URL + '/categories/master-division/update?id=';
export const MASTER_DIVISION_DELETE: string = BASE_URL + '/categories/master-division/delete?id=';

// Master Categories
export const MASTER_CATEGORIES_FIND_MANY: string =
  BASE_URL + '/categories/master-categories/find-many';
export const MASTER_CATEGORIES_CREATE: string = BASE_URL + '/categories/master-categories/create';
export const MASTER_CATEGORIES_UPDATE: string =
  BASE_URL + '/categories/master-categories/update?id=';
export const MASTER_CATEGORIES_DELETE: string =
  BASE_URL + '/categories/master-categories/delete?id=';

// Master Sub Categories
export const MASTER_SUB_CATEGORIES_FIND_MANY: string =
  BASE_URL + '/categories/master-sub-categories/find-many';
export const MASTER_SUB_CATEGORIES_CREATE: string =
  BASE_URL + '/categories/master-sub-categories/create';
export const MASTER_SUB_CATEGORIES_UPDATE: string =
  BASE_URL + '/categories/master-sub-categories/update?id=';
export const MASTER_SUB_CATEGORIES_DELETE: string =
  BASE_URL + '/categories/master-sub-categories/delete?id=';

// Main Group
export const MAIN_GROUP_FIND_MANY: string = BASE_URL + '/categories/main-group/find-many';
export const MAIN_GROUP_CREATE: string = BASE_URL + '/categories/main-group/create';
export const MAIN_GROUP_DELETE: string = BASE_URL + '/categories/main-group/delete';
// Divisions
export const DIVISION_FIND_MANY: string = BASE_URL + '/categories/division/find-many';
export const DIVISION_CREATE: string = BASE_URL + '/categories/division/create';
export const DIVISION_DELETE: string = BASE_URL + '/categories/division/delete';
// Categories
export const CATEGORIES_FIND_MANY: string = BASE_URL + '/categories/categories/find-many';
export const CATEGORIES_CREATE: string = BASE_URL + '/categories/categories/create';
export const CATEGORIES_DELETE: string = BASE_URL + '/categories/categories/delete';
// SubCategories
export const SUB_CATEGORY_FIND_MANY: string = BASE_URL + '/categories/sub-categories/find-many';
export const SUB_CATEGORY_CREATE: string = BASE_URL + '/categories/sub-categories/create';
export const SUB_CATEGORY_DELETE: string = BASE_URL + '/categories/sub-categories/delete';
